import React, { useEffect, useState, Fragment } from "react";
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { Link } from "react-router-dom";
import CardModal from "../../CardModal.jsx";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from '../../button/button-st1/index.jsx';
import img1 from '../../.././assets/images/box-item/profile.jpg';
import icon from '../../.././assets/images/icon/icon-check.svg';
import icon2 from '../../.././assets/images/icon/icon-diamond.svg';
//import img2 from '../../.././assets/images/box-item/profile-cover.jpg';
import { Dropdown } from "react-bootstrap";

import { fileBaseUrl } from '../../../api/constants.js';
//submit Request
//Bckend Connection
import { submitRequest } from "../../../api/requestApi.js";

//showing messages
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//upload file
import Papa from 'papaparse';

// Backend Connection
import { editClient } from "../../../api/auth.js";


import { getClientProfile } from '../../../api/dttuningApi.js';

// For photo
import {
    uploadCRMFile, uploadWebsiteFile, uploadSocialFile, uploadEcommerceFile,
    uploadEmailmarketingFile, uploadCustomersupportFile, uploadCompanyInfo
} from '../../../api/dttuningApi.js';
import axios from "axios";
import { API_URL } from "../../../api/constants.js";


const Profile = (props) => {
    const email = localStorage.getItem('email');

    /*
    useEffect(() => {
        // Check if the page has already been reloaded
        if (!sessionStorage.getItem('reloaded')) {
            // Reload the page
            sessionStorage.setItem('reloaded', 'true');
            window.location.reload();
        } else {
            // Clear the flag so that it doesn't persist
            sessionStorage.removeItem('reloaded');
        }
    }, []);
*/
    const [profilePhoto, setProfilePhoto] = useState(img1);
    const [twinData, setTwinData] = useState({
        email: '',
        first_name: '',
        last_name: '',
        company_name: '',
        position: '',
        company_owner: '',
        phone: '',
        vatid: '',
        time_zone: '',
        address: '',
        client_photo_link: '',
    });




    const handleInputChange = (e) => {
        setTwinData({ ...twinData, [e.target.name]: e.target.value });
    };


    const handleEdit = async (event) => {
        //twinData.email = localStorage.getItem('email');
        event.preventDefault();
        try {
            console.log('twinData that is sending to back:', twinData);
            const response = await editClient(twinData);
            if (response && response.success) {
                toast.success('Edit successful!', { position: 'top-right', autoClose: 3000 });
                setTimeout(() => window.location.href = '/dashboard-client', 3000);
            } else {
                toast.error(`Edit failed: ${response.message}`, { position: 'top-right', autoClose: 3000 });
            }
        } catch (error) {
            console.error('Edit error', error);
            toast.error('Edit failed!', { position: 'top-right', autoClose: 3000 });
        }
    };



    /////////////////////////////////////CRM file
    const [crmData, setCRMData] = useState([]);
    const [crmFile, setCRMFile] = useState(null);

    // Handle file change and parsing
    const handleCRMFileChange = (event) => {
        event.preventDefault();

        // Safeguard to ensure files exist
        const fileList = event.target?.files;
        if (!fileList || fileList.length === 0) {
            console.error('No files were uploaded');
            return;
        }

        const uploadedCRMFile = fileList[0];
        setCRMFile(uploadedCRMFile);

        // Parse CSV file with PapaParse
        Papa.parse(uploadedCRMFile, {
            complete: (result) => {
                console.log('Parsed CSV Data:', result.data);
                setCRMData(result.data);
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    ///CRM upload to back
    const handleCRMUpload = async (event) => {
        event.preventDefault();
        if (!email) {
            console.log("No email found in local storage.");
            return;
        }
        if (!crmFile) {
            console.error("No CRM file selected.");
            return;
        }
        const formData = new FormData();
        formData.append('crmFile', crmFile);

        try {
            const response = await uploadCRMFile(email, formData);
            console.log("Upload successful:", response);
            toast.success("CRM Data uploaded successfully!");
        } catch (error) {
            console.error("Error uploading CRM File:", error);
            toast.error("Error uploading CRM File.");
        }
    };

    /////////////////////////////////////////////

    ///////////////////////////////////////upload Website Analytics file

    const [websiteData, setWebsiteData] = useState([]);
    const [websiteFile, setWebsiteFile] = useState(null);

    // Handle file change and parsing
    const handleWebsiteFileChange = (event) => {
        event.preventDefault();

        // Safeguard to ensure files exist
        const fileList = event.target?.files;
        if (!fileList || fileList.length === 0) {
            console.error('No files were uploaded');
            return;
        }

        const uploadedWebsiteFile = fileList[0];
        setWebsiteFile(uploadedWebsiteFile);

        // Parse CSV file with PapaParse
        Papa.parse(uploadedWebsiteFile, {
            complete: (result) => {
                console.log('Parsed CSV Data:', result.data);
                setWebsiteData(result.data);
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    ///CRM upload to back
    const handleWebsiteFileUpload = async (event) => {
        event.preventDefault();
        if (!email) {
            console.log("No email found in local storage.");
            return;
        }
        if (!websiteFile) {
            console.error("No Website file selected.");
            return;
        }
        const formData = new FormData();
        formData.append('websiteFile', websiteFile);

        try {
            const response = await uploadWebsiteFile(email, formData);
            console.log("Upload successful:", response);
            toast.success("Website Data uploaded successfully!");
        } catch (error) {
            console.error("Error uploading CRM File:", error);
            toast.error("Error uploading CRM File.");
        }
    };

    /////////////////////////////////////////////

    /////////////////////////////////////////upload Social file


    const [socialData, setSocialData] = useState([]);
    const [socialFile, setSocialFile] = useState(null);

    // Handle file change and parsing
    const handleSocialFileChange = (event) => {
        event.preventDefault();

        // Safeguard to ensure files exist
        const fileList = event.target?.files;
        if (!fileList || fileList.length === 0) {
            console.error('No files were uploaded');
            return;
        }

        const uploadedSocialFile = fileList[0];
        setSocialFile(uploadedSocialFile);

        // Parse CSV file with PapaParse
        Papa.parse(uploadedSocialFile, {
            complete: (result) => {
                console.log('Parsed CSV Data:', result.data);
                setSocialData(result.data);
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    ///CRM upload to back
    const handleSocialFileUpload = async (event) => {
        event.preventDefault();
        if (!email) {
            console.log("No email found in local storage.");
            return;
        }
        if (!socialFile) {
            console.error("No Social file selected.");
            return;
        }
        const formData = new FormData();
        formData.append('socialFile', socialFile);

        try {
            const response = await uploadSocialFile(email, formData);
            console.log("Upload successful:", response);
            toast.success("Social Data uploaded successfully!");
        } catch (error) {
            console.error("Error uploading Social File:", error);
            toast.error("Error uploading Social File.");
        }
    };

    /////////////////////////////////////////////
    ///////////////////////////////////////////upload Ecommerce file

    const [ecommerceData, setEcommerceData] = useState([]);
    const [ecommerceFile, setEcommerceFile] = useState(null);

    // Handle file change and parsing
    const handleEcommerceFileChange = (event) => {
        event.preventDefault();

        // Safeguard to ensure files exist
        const fileList = event.target?.files;
        if (!fileList || fileList.length === 0) {
            console.error('No files were uploaded');
            return;
        }

        const uploadedEcommerceFile = fileList[0];
        setEcommerceFile(uploadedEcommerceFile);

        // Parse CSV file with PapaParse
        Papa.parse(uploadedEcommerceFile, {
            complete: (result) => {
                console.log('Parsed CSV Data:', result.data);
                setEcommerceData(result.data);
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    ///CRM upload to back
    const handleEcommerceFileUpload = async (event) => {
        event.preventDefault();
        if (!email) {
            console.log("No email found in local storage.");
            return;
        }
        if (!ecommerceFile) {
            console.error("No Ecommerce file selected.");
            return;
        }
        const formData = new FormData();
        formData.append('ecommerceFile', ecommerceFile);

        try {
            const response = await uploadEcommerceFile(email, formData);
            console.log("Upload successful:", response);
            toast.success("Ecommerce Data uploaded successfully!");
        } catch (error) {
            console.error("Error uploading Ecommerce File:", error);
            toast.error("Error uploading Ecommerce File.");
        }
    };

    /////////////////////////////////////////////
    /////////////////////////////////////////////upload Email Marketing  file

    const [emailData, setEmailData] = useState([]);
    const [emailFile, setEmailFile] = useState(null);

    // Handle file change and parsing
    const handleEmailFileChange = (event) => {
        event.preventDefault();

        // Safeguard to ensure files exist
        const fileList = event.target?.files;
        if (!fileList || fileList.length === 0) {
            console.error('No files were uploaded');
            return;
        }

        const uploadedEmailFile = fileList[0];
        setEmailFile(uploadedEmailFile);

        // Parse CSV file with PapaParse
        Papa.parse(uploadedEmailFile, {
            complete: (result) => {
                console.log('Parsed CSV Data:', result.data);
                setEmailData(result.data);
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    ///CRM upload to back
    const handleEmailFileUpload = async (event) => {
        event.preventDefault();
        if (!email) {
            console.log("No email found in local storage.");
            return;
        }
        if (!emailFile) {
            console.error("No Email file selected.");
            return;
        }
        const formData = new FormData();
        formData.append('emailFile', emailFile);

        try {
            const response = await uploadEmailmarketingFile(email, formData);
            console.log("Upload successful:", response);
            toast.success("Email Marketing Data uploaded successfully!");
        } catch (error) {
            console.error("Error uploading Email marketing File:", error);
            toast.error("Error uploading Email moarketing File.");
        }
    };

    /////////////////////////////////////////////
    /////////////////////////////////////////////upload Custommer Support  file

    const [cusSupData, setCusSupData] = useState([]);
    const [cusSupFile, setCusSupFile] = useState(null);
    // Handle file change and parsing
    const handleCusSupFileChange = (event) => {
        event.preventDefault();

        // Safeguard to ensure files exist
        const fileList = event.target?.files;
        if (!fileList || fileList.length === 0) {
            console.error('No files were uploaded');
            return;
        }

        const uploadedCusSupFile = fileList[0];
        setCusSupFile(uploadedCusSupFile);

        // Parse CSV file with PapaParse
        Papa.parse(uploadedCusSupFile, {
            complete: (result) => {
                console.log('Parsed CSV Data:', result.data);
                setCusSupData(result.data);
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    ///CRM upload to back
    const handleCusSupFileUpload = async (event) => {
        event.preventDefault();
        if (!email) {
            console.log("No email found in local storage.");
            return;
        }
        if (!cusSupFile) {
            console.error("No Customer Support file selected.");
            return;
        }
        const formData = new FormData();
        formData.append('cusSupFile', cusSupFile);

        try {
            const response = await uploadCustomersupportFile(email, formData);
            console.log("Upload successful:", response);
            toast.success("Customer Support Data uploaded successfully!");
        } catch (error) {
            console.error("Error uploading Customer Support File:", error);
            toast.error("Error uploading Customer Support File.");
        }
    };

    /////////////////////////////////////////////



    /////////////////////////////



    const data = props.data;
    const [modalShow, setModalShow] = useState(false);


    ///new col
    const [conversations, setConversations] = useState([]);



    ///Output Format 
    const [selectedFrameSize, setSelectedFrameSize] = useState("Click to Select One of the Items Listed");
    const [frameSizeList] = useState(
        [
            {
                id: 1,
                title: "640x480 (VGA)",
            },
            {
                id: 2,
                title: "720x480 (SD)",
            },
            {
                id: 3,
                title: "1280x720 (HD)",
            },
            {
                id: 4,
                title: "1920x1080 (Full HD)",
            },
        ]
    )
    const handleFrameSizeClick = (title) => {
        setSelectedFrameSize(title);
        handleInputChange({ target: { name: 'frameSize', value: title } });
    };



    ///Submit Request:
    const stored_email = localStorage.getItem('email');
    const stored_first_name = localStorage.getItem('firstName');
    const stored_last_name = localStorage.getItem('lastName');

    const [requestData, setRequestData] = useState({
        clientEmail: stored_email,
        clientFirstName: stored_first_name,
        clientLastName: stored_last_name,
        freelancerEmail: '',
        freelancerFirstName: '',
        freelancerLastName: '',
        collaborationPeriod: '',
        title: '',
        category: '',
        size: '',
        experiexperienceLevel: '',
        budget: 0,
        outputFormat: '',
        fps: 30,
        frameSize: '',
        projectTags: '',
        projectDescription: '',
        rfpLink: '',
        shotDuration: '',
        light: '',
        exposure: '',
        imageDepth: '',
        camera: '',
        lens: '',
        quality: '',
        color: '',
        inferiorcolor: '',
        tiltMovement: '',
        panMovement: '',
        craneMovement: '',
        dollyMovement: '',
        aerialShot: '',
        objectsInView: '',
        descriptionOfObject: '',
        objectRatio: '',
        numberOfActors: '',
        actsOfActor: '',
        innovation: '',
        storyboard: ''
    });

    const [requestSuccess, setRequestSuccess] = useState(false); // New state for success message





    const [isExpanded, setIsExpanded] = useState(false);

    const toggleSettings = () => {
        setIsExpanded(!isExpanded);
    };

    const advButtonStyle = {
        padding: '10px 20px', // Adjust padding for desired size
        backgroundColor: 'rgb(241, 77, 128)', // Set background color using RGB values
        color: '#ffffff', // Set text color
        border: 'none', // Remove border
        borderRadius: '5px', // Add border radius for rounded corners
        cursor: 'pointer', // Change cursor to pointer on hover
    };
    const navigate = useNavigate(); // Initialize useNavigate hook

    const handleEditClick = () => {
        navigate('/editProfile-client');
    };


    // Controlled state for selected tab index
    const [selectedTab, setSelectedTab] = useState(0);

    const handleTabSelect = (index) => {
        setSelectedTab(index);
    };

    ///Upload company Info
    const [companyInfo, setCompanyInfo] = useState({
        companyName: "",
        industryCategory: "",
        productsServices: "",
    });

    const handleCompanyInputChange = (e) => {
        const { name, value } = e.target;
        setCompanyInfo((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleRequest = async () => {
        try {
            const email = localStorage.getItem("email"); // Retrieve email from local storage
            if (!email) {
                alert("Email not found. Please log in first.");
                return;
            }

            // Filter out empty fields
            const payload = Object.fromEntries(
                Object.entries(companyInfo).filter(([_, value]) => value && value.trim() !== "")
            );

            console.log("Filtered payload:", payload);

            if (Object.keys(payload).length === 0) {
                // If no data is provided, skip the API call but still navigate
                console.log("No data provided. Skipping API call.");
                toast.info('Proceeding to dashboard.', {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                setTimeout(() => {
                    window.location.href = '/dashboard-b2c'; // Navigate to the next page
                }, 2000);
                return;
            }

            // API call to post data
            const response = await uploadCompanyInfo(email, payload);
            console.log("Info uploaded successfully:", response);

            // Notify success
            toast.success('Submission successful: Check "Your Dashboard"', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            setTimeout(() => {
                window.location.href = '/dashboard-b2c'; // Navigate to the next page
            }, 2000);
        } catch (error) {
            console.error("Submission error", error);

            toast.error("Submission failed!", {
                position: "top-right",
                autoClose: 5000,
            });
        }
    };




    return (
        <Fragment>
            <div className="container">
                <div className="tf-section flat-author-profile flat-explore flat-auctions ">
                    <div className="row">
                        <div className="col-lg-10 col-md-12">
                            <div className="container">
                                <div className="flat-tabs tab-author">

                                    <div
                                        style={{
                                            border: "1px solid gray", borderRadius: "1em", backgroundColor: 'rgb(253, 253, 253)'
                                        }}
                                    >
                                        <ToastContainer /> {/* Add the ToastContainer component for showing messages */}

                                        {
                                            <div className="tf-section flat-explore flat-edit-profile flat-auctions-details" >
                                                <div className="container" >
                                                    <div className="form-upload-profile post" >
                                                        <form action="#" className="form-profile" style={{ position: 'relative' }}>
                                                            <div className="form-infor-profile">
                                                                <div>
                                                                    {/* File Input */}

                                                                    <h2>Upload Audience Data for B2C Business</h2>
                                                                    {/*
                                                                    <h3 className="title-one fw-6"> <br /> <br /> Company Information</h3>

                                                                  
                                                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10%", alignItems: "center" }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", maxWidth: "45%" }}>
                                                                            <p className=" fw-5" >Company Name</p>
                                                                            <input
                                                                                type="text"
                                                                                name="companyName" // Add name attribute
                                                                                onChange={handleCompanyInputChange}
                                                                                placeholder="Enter Company Name"
                                                                                style={{ marginBottom: "1em", width: "100%" }}
                                                                            />
                                                                        </div>
                                                                        <div style={{ display: "flex", flexDirection: "column", maxWidth: "45%" }}>
                                                                            <p className="fw-5">Industry Category</p>
                                                                            <input
                                                                                type="text"
                                                                                name="industryCategory" // Add name attribute
                                                                                onChange={handleCompanyInputChange}
                                                                                placeholder="Describe your industry"
                                                                                style={{ marginBottom: "1em", width: "100%" }}
                                                                            />
                                                                        </div>
                                                                    </div>


                                                                    <p className="fw-5">Products (Services)</p>
                                                                    <textarea
                                                                        type="text"
                                                                        name="productsServices" // Add name attribute
                                                                        onChange={handleCompanyInputChange}
                                                                        placeholder="Write about your products (services)"
                                                                        style={{ marginBottom: "1em", maxWidth: "75%" }}
                                                                    />

/*}

                                                                    {/* File Input */}



                                                                    <h3 className="title-one fw-6"> <br /> <br /> 1. Website Analytics DATA</h3>
                                                                    <p className="title-one fw-6">Page views, product views, session duration, conversion rates.
                                                                        <br />Name, Email(User ID), Sessions, Bounce Rate, Time Spent on Site, Conversion Status
                                                                    </p>
                                                                    <div>
                                                                        <button
                                                                            style={{ zIndex: 0, maxWidth: '15em', marginBottom: "2em", padding: "0.5em", backgroundColor: "black", borderColor: "darkorange", fontSize: "1.2em" }}
                                                                            onClick={() => window.open("https://docs.google.com/spreadsheets/d/1X5hcFwMKOrBvmXRFCdCEN0RVtQi8TC5dL6tJzq03K8o/edit?usp=sharing", "_blank")}
                                                                        >
                                                                            Check Input Format
                                                                        </button>
                                                                    </div>                                                                  {/* File Input */}
                                                                    <input
                                                                        type="file"
                                                                        accept=".csv"
                                                                        onChange={handleWebsiteFileChange}
                                                                    />

                                                                    {/* Show uploaded file name */}
                                                                    {websiteFile && <p>File uploaded: {websiteFile.name}</p>}

                                                                    {/* Show data preview (first 5 rows) */}
                                                                    {websiteData.length > 0 && (
                                                                        <div>
                                                                            <h3 style={{ marginBottom: "1em" }}>Data Preview (First 5 Records):</h3>
                                                                            <table border="1">
                                                                                <thead>
                                                                                    <tr>
                                                                                        {Object.keys(websiteData[0]).map((header, index) => (
                                                                                            <th key={index}>{header}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {websiteData.slice(0, 5).map((row, index) => (
                                                                                        <tr key={index}>
                                                                                            {Object.values(row).map((value, idx) => (
                                                                                                <td key={idx}>{value}</td>
                                                                                            ))}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                    {/* Submit button */}
                                                                    {websiteData.length > 0 && (
                                                                        <button
                                                                            style={advButtonStyle}
                                                                            onClick={handleWebsiteFileUpload}>Submit Website Analytics Data</button>
                                                                    )}



                                                                    <h3 className="title-one fw-6"> <br /> <br /> 2. Social Media DATA</h3>
                                                                    <p className="title-one fw-6"> Content of Posts, Likes, comments, shares, follows on social media platforms (Facebook, Instagram, etc.).
                                                                        <br />
                                                                    </p>
                                                                    <div>
                                                                        <button
                                                                            style={{ zIndex: 0, maxWidth: '15em', marginBottom: "2em", padding: "0.5em", backgroundColor: "black", borderColor: "darkorange", fontSize: "1.2em" }}
                                                                            onClick={() => window.open("https://docs.google.com/spreadsheets/d/1gIbxeTm5ZpBfdz0G7Rd-QNWFi78ya5R4xE_u6EnwGIY/edit?usp=sharing", "_blank")}
                                                                        >
                                                                            Check Input Format
                                                                        </button>
                                                                    </div> 
                                                                    {/* File Input */}
                                                                    <input
                                                                        type="file"
                                                                        accept=".csv"
                                                                        onChange={handleSocialFileChange}
                                                                    />

                                                                    {/* Show uploaded file name */}
                                                                    {socialFile && <p>File uploaded: {socialFile.name}</p>}

                                                                    {/* Show data preview (first 5 rows) */}
                                                                    {socialData.length > 0 && (
                                                                        <div>
                                                                            <h3 style={{ marginBottom: "1em" }}>Data Preview (First 5 Records):</h3>
                                                                            <table border="1">
                                                                                <thead>
                                                                                    <tr>
                                                                                        {Object.keys(socialData[0]).map((header, index) => (
                                                                                            <th key={index}>{header}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {socialData.slice(0, 5).map((row, index) => (
                                                                                        <tr key={index}>
                                                                                            {Object.values(row).map((value, idx) => (
                                                                                                <td key={idx}>{value}</td>
                                                                                            ))}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                    {/* Submit button */}
                                                                    {socialData.length > 0 && (
                                                                        <button
                                                                            style={advButtonStyle}
                                                                            onClick={handleSocialFileUpload}>Submit Social Media Data</button>
                                                                    )}








                                                                    <h3 className="title-one fw-6"> <br /> <br /> 3. Customer Support DATA</h3>
                                                                    <p className="title-one fw-6">Chat logs, feedback forms, complaint tickets.
                                                                        <br />Name, Email, Ticket ID, Customer ID, Issue Type, Resolution Time, Feedback Score
                                                                    </p>
                                                                    <div>
                                                                        <button
                                                                            style={{ zIndex: 0, maxWidth: '15em', marginBottom: "2em", padding: "0.5em", backgroundColor: "black", borderColor: "darkorange", fontSize: "1.2em" }}
                                                                            onClick={() => window.open("https://docs.google.com/spreadsheets/d/1insxNbyAydYSHq6qAVtZtlJjxuiohGa2yKg4vdrjnnA/edit?usp=sharing", "_blank")}
                                                                        >
                                                                            Check Input Format
                                                                        </button>
                                                                    </div> 
                                                                    {/* File Input */}
                                                                    <input
                                                                        type="file"
                                                                        accept=".csv"
                                                                        onChange={handleCusSupFileChange}
                                                                    />

                                                                    {/* Show uploaded file name */}
                                                                    {cusSupFile && <p>File uploaded: {cusSupFile.name}</p>}

                                                                    {/* Show data preview (first 5 rows) */}
                                                                    {cusSupData.length > 0 && (
                                                                        <div>
                                                                            <h3 style={{ marginBottom: "1em" }}>Data Preview (First 5 Records):</h3>
                                                                            <table border="1">
                                                                                <thead>
                                                                                    <tr>
                                                                                        {Object.keys(cusSupData[0]).map((header, index) => (
                                                                                            <th key={index}>{header}</th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {cusSupData.slice(0, 5).map((row, index) => (
                                                                                        <tr key={index}>
                                                                                            {Object.values(row).map((value, idx) => (
                                                                                                <td key={idx}>{value}</td>
                                                                                            ))}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                    {/* Submit button */}
                                                                    {cusSupData.length > 0 && (
                                                                        <button
                                                                            style={advButtonStyle}
                                                                            onClick={handleCusSupFileUpload}>Submit Customer Support Data</button>
                                                                    )}



                                                                </div>
                                                                <h3 className="title-one fw-6"> <br /> <br /> 4. CRM DATA</h3>
                                                                <p className="title-one fw-6">Customer profiles, purchase history, customer support interactions.
                                                                    <br />Name, Email, Phone, Purchase History, Last Interaction Date
                                                                </p>
                                                                <div>
                                                                        <button
                                                                            style={{ zIndex: 0, maxWidth: '15em', marginBottom: "2em", padding: "0.5em", backgroundColor: "black", borderColor: "darkorange", fontSize: "1.2em" }}
                                                                            onClick={() => window.open("https://docs.google.com/spreadsheets/d/1U2244eFcynOtEsniJGuVF7Pm7vCAku3OTzJHdd9wlq8/edit?usp=sharing", "_blank")}
                                                                        >
                                                                            Check Input Format
                                                                        </button>
                                                                    </div> 
                                                                {/* File Input */}
                                                                <input
                                                                    type="file"
                                                                    accept=".csv"
                                                                    onChange={handleCRMFileChange}
                                                                />


                                                                {/* Show uploaded file name */}
                                                                {crmFile && <p>File uploaded: {crmFile.name}</p>}

                                                                {/* Show data preview (first 5 rows) */}
                                                                {crmData.length > 0 && (
                                                                    <div>
                                                                        <h3 style={{ marginBottom: "1em" }}>Data Preview (First 5 Records):</h3>
                                                                        <table border="1">
                                                                            <thead>
                                                                                <tr>
                                                                                    {Object.keys(crmData[0]).map((header, index) => (
                                                                                        <th key={index}>{header}</th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {crmData.slice(0, 5).map((row, index) => (
                                                                                    <tr key={index}>
                                                                                        {Object.values(row).map((value, idx) => (
                                                                                            <td key={idx}>{value}</td>
                                                                                        ))}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}

                                                                {/* Submit button */}
                                                                {crmData.length > 0 && (
                                                                    <button
                                                                        style={advButtonStyle}
                                                                        type="file"
                                                                        //onClick={handleCRMSubmit}
                                                                        onClick={handleCRMUpload}

                                                                    >Submit CRM Data</button>
                                                                )}


                                                                <br /><br /><br />

                                                            </div>
                                                            <button className="tf-button-submit mg-t-15" style={{ zIndex: 0, maxWidth: '30em' }}
                                                                onClick={e => {
                                                                    e.preventDefault(); // Prevent the default form submission behavior
                                                                    handleRequest();
                                                                }}>
                                                                Start Digital Twin Tuning!
                                                            </button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div >
                            </div >
                            <CardModal show={modalShow} onHide={() => setModalShow(false)} />
                        </div>

                    </div>
                </div>
            </div>
        </Fragment >
    );
};


export default Profile;
